import { PermissionRules, PERMISSIONS } from '@teamworksdev/influencer/core';
import { isComplianceOfficer } from './roles';

const hasTransactionsImportWrite = PermissionRules.or(
	isComplianceOfficer,
	PermissionRules.hasTeamPermission(PERMISSIONS.TRANSACTIONS_IMPORT_WRITE),
);

const accessUploadTransactions = hasTransactionsImportWrite;

export {
	hasTransactionsImportWrite,
	accessUploadTransactions,
};
